<template>
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="14" cy="14" r="14" fill="#FFF"/>
    <path d="M20 9.41L18.59 8L14 12.59L9.41 8L8 9.41L12.59 14L8.00002 18.59L9.41002 20L14 15.41L18.59 20L20 18.59L15.41 14L20 9.41Z" fill="#000"/>
  </svg>
</template>
